import React from 'react';
import "./css/Home.css"

const Politica_cookies = () => {
  return (
    <div className="container_header">
    <div className="centrado">
    <div className="col-12 col-md-12 contenedor_global">        <div className="row contenedor_fila flex-column flex-md-row">
    {/* Primer Contenedor */}
    <div className="box col-12 d-flex centrar_texto justify-content-center">
      <div className="titulo">
      Política de Cookies
      </div>
      <div className="texto">
      En Ajesl.es utilizamos cookies para mejorar tu experiencia en nuestro sitio web. En esta política te explica qué cookies usamos, por qué las usamos y cómo puedes gestionarlas.
      </div>
    </div>
    {/* Primer Contenedor */}
    <div className="box2 col-12 d-flex centrar_texto">
      <div className="titulo2">
      ¿Qué son las cookies?
      </div>
      <div className="texto2">
      Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Permiten al sitio web recordar tus preferencias y acciones durante un periodo de tiempo, de modo que no tengas que volver a introducir esa información cada vez que regresas al sitio.
      </div>
    </div>
    <div className="box col-12 d-flex centrar_texto">
      <div className="titulo">
      Cookies utilizadas en nuestro sitio
      </div>
      <div className="texto">
      <ul>
          <li><strong>Cookies de sesión:</strong> Se utilizan cuando inicias sesión y se eliminan automáticamente cuando cierras sesión.</li>
          <li><strong>Cookies de autenticación:</strong> Se utilizan para recordar tu sesión y mantenerte conectado.</li>
        </ul>
    </div>
    </div>
    <div className="box2 col-12 d-flex centrar_texto">
      <div className="titulo2">
      ¿Por qué utilizamos cookies?
      </div>
      <div className="texto2">
      <ul>
          <li><strong>Autenticación:</strong> Para recordar tus credenciales de inicio de sesión.</li>
          <li><strong>Seguridad:</strong> Para garantizar que tu cuenta se mantenga segura.</li>
          <li><strong>Mejora de la experiencia:</strong> Para ofrecerte una experiencia más fluida.</li>
        </ul>
        <p>
          Puedes controlar el uso de cookies en cualquier momento a través de la configuración de tu navegador. Si desactivas las cookies, algunas funcionalidades del sitio pueden no estar disponibles o no funcionar correctamente.
        </p>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
  );
};

export default Politica_cookies;